<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  background-color: #333;
}
/*滚动条的轨道*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #fff;
  background-color: #fff;
}
/*滚动条的滑块按钮*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #fff;
  box-shadow: inset 0 0 5px #000;
}
/*滚动条的上下两端的按钮*/
::-webkit-scrollbar-button {
  height: 5px;
  background-color: #fff;
}
#app {
  width: 100%;
  height: 100%;
  // position: relative;
  // font-family: "PingFangHeavy";
  font-size: 14px;
  background-color: #f6f8f9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue